import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import { SGSForm, SGSFormDate, SGSFormLayout } from 'components';
import { endOfMonth, format, startOfMonth, subMonths } from 'date-fns';
import { useArretTravailFormContext } from 'features/arretTravail/contexts/ArretTravailFormProvider';
import useValidationEffects from 'features/arretTravail/hooks/useValidationEffects';
import { FormProvider, SubmitHandler, useFieldArray, useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { useSalaryPeriodSchema } from './schema';
import { TableSalairePeriod } from './table';
import TableSuspensionPeriod from './tableSuspensionPeriod';

type Props = {
    store: any;
    onSubmit: SubmitHandler<SalairePeriodSchema>;
    actions?: JSX.Element;
};

export type ISalairePeriod = {
    id: string;
    startDate?: string;
    endDate?: string;
    salaryBrut: string;
    primesBrut: string;
    salaryNet: string;
    primesNet: string;
};

export type SuspensionPeriod = {
    id: string;
    startDate: Date;
    endDate: Date;
};

type SalairePeriodSchema = {
    salaryReferences: { salaries: ISalairePeriod[] };
    suspensions: SuspensionPeriod[];
    dateIndemnisationCcn: Date | null;
};

// TODO :: split code into 2 differents forms ?

const FormSalaryReference: React.FC<Props> = ({ onSubmit, store, actions }) => {
    const { activeStep, setStepFailed, ficheParametrage } = useArretTravailFormContext();

    const accidentDate = store?.workStoppage?.infos?.start ?? null;
    const nbrMonth = ficheParametrage?.ficheDeParametrageTrouve === '1' ? ficheParametrage.salairesDeRef?.nbMois ?? 14 : 14;

    const initialSalaires = Array.from({ length: nbrMonth }, (_, index) => {
        const date = subMonths(new Date(accidentDate), index);
        return {
            id: `${index + 1}`,
            startDate: format(startOfMonth(date), 'yyyy-MM-dd'),
            endDate: format(endOfMonth(date), 'yyyy-MM-dd'),
        };
    });
    const initialSuspensions = [
        {
            id: 1,
            startDate: null,
            endDate: null,
        },
    ];

    const validationSchema: Yup.SchemaOf<SalairePeriodSchema> = useSalaryPeriodSchema();

    console.log(store.salaryReferences.salaries);

    const methods = useForm<SalairePeriodSchema>({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            ...store,
            salaryReferences: {
                salaries: store?.salaryReferences?.salaries.length ? store.salaryReferences.salaries : initialSalaires,
            },
            suspensions: store?.suspensions?.length ? store?.suspensions : initialSuspensions,
            dateIndemnisationCcn: store?.dateIndemnisationCcn ?? null,
        },
    });

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = methods;

    useValidationEffects({ errors, activeStep, setStepFailed, control });

    const { fields: salaries } = useFieldArray<SalairePeriodSchema, 'salaryReferences.salaries', 'id'>({
        control,
        name: 'salaryReferences.salaries',
        keyName: 'id',
    });

    console.log(salaries);

    const {
        fields: suspensions,
        append: appendSalary,
        remove: removeSalary,
    } = useFieldArray<SalairePeriodSchema, 'suspensions', 'id'>({
        control,
        name: 'suspensions',
        keyName: 'id',
    });

    const handleNewSalaire = () => {
        appendSalary({
            id: `${suspensions.length + 1}`,
            startDate: null,
            endDate: null,
        });
    };

    console.log(errors);

    return (
        <>
            <FormProvider {...methods}>
                <SGSFormLayout onSubmit={handleSubmit(onSubmit)} actions={actions}>
                    <Grid container justifyContent="center" style={{ marginBottom: '20px' }}>
                        <Grid item xs={12} md={12}>
                            <SGSForm.Row>
                                <SGSForm.Col md={4}>
                                    <SGSFormDate inputVariant="outlined" name="dateIndemnisationCcn" label={"Date de début d'indéminisation (relais CCN)"} />
                                </SGSForm.Col>
                            </SGSForm.Row>
                        </Grid>
                        <Grid item xs={8}></Grid>
                        <Grid item xs={12} md={12}>
                            <TableSalairePeriod salaries={salaries} store={store} setValue={setValue} ficheParametrage={ficheParametrage} />
                        </Grid>
                    </Grid>
                    <TableSuspensionPeriod suspensions={suspensions} appendSalary={handleNewSalaire} removeSalary={removeSalary} store={store} />
                </SGSFormLayout>
            </FormProvider>
        </>
    );
};

export default FormSalaryReference;
